import Feedback from './Feedback';

export const SurveyWizard = Feedback;
